import React from "react";
import Dialog from "@mui/material/Dialog";
import { Form, Formik, FormikHelpers } from "formik";
import { object } from "yup";
import { UserFormValues } from "src/models/User.model";
import UserForm from "../Layouts/UserForm";
import { showToast } from "src/utils/showToaster";
import { useAddUserMutation } from "src/services/UserService";

type Props = {
  onClose: () => void;
};

const AddUserFormWrapper = ({ onClose }: Props) => {
  const [addUser] = useAddUserMutation();

  // Form Initial Values
  const initialValues: UserFormValues = {
    firstName: "",
    lastName:"",
    email: "",
    password: "",
    mobile: "",
    altMobile: "",
    dob: "",
    gender: "",
    upiId: "",
    subjects: "",
    walletAmount: 0,
    course: "",
    level: "",
    referralCode: "",
    referralBy: "",
    bankAccountDetails: [
      {
        accountHolderName: "",
        bankAccountNumber: "",
        ifscCode: "",
        bankName: "",
        branchName: "",
      },
    ],
    address: [
      {
        country: "",
        state: "",
        city: "",
        pincode: "",
        addressLine: "",
        landmark: "",
        addressType: "",
      },
    ],
  };

  // Validation Schema
  const validationSchema = object().shape({
    // email: string().email().required("Please enter email"),
    // password: string().required("Please enter password"),
    // mobile: string()
    //   .matches(/^[0-9]{10}$/, {
    //     message: "Mobile number should contain exactly 10 digits.",
    //   })
    //   .required("Please enter mobile number"),
    // altMobile: string().matches(/^[0-9]{10}$/, {
    //   message: "Mobile number should contain exactly 10 digits.",
    // }),
    // state: string().required("Please enter state"),
    // city: string().required("Please enter city"),
    // pincode: string().required("Please enter pincode"),
    // addressLine: string().required("Please enter address"),
    // accountHolderName: string().required("Please enter account holder name"),
    // bankAccountNumber: string()
    //   .trim()
    //   .matches(/^\d{12,18}$/, {
    //     message: "Bank account number must be 12 to 18 digits",
    //   })
    //   .required("Please enter bank account number"),
    // ifscCode: string()
    //   .matches(/^[A-Z]{4}0[A-Z0-9]{6}$/, {
    //     message: "Invalid IFSC code",
    //   })
    //   .required("Please enter IFSC code"),
    // bankName: string().required("Please enter bank name"),
    // branchName: string().required("Please enter branch name"),
  });
  // Handle Submit
  const handleSubmit = (
    values: UserFormValues,
    { setSubmitting, resetForm }: FormikHelpers<UserFormValues>
  ) => {
    const payload = {
       firstName:values?.firstName || "",
      lastName:values?.lastName || "",
      mobile: values?.mobile,
      email: values?.email,
      password: values?.password,
      altMobile: values?.altMobile,
      dob: values?.dob,
      gender: values.gender?.value,
      upiId: values?.upiId,
      // subjects: values.subjects.map((sub : any) =>({
      // })),
      walletAmount: values?.walletAmount,
      course: values?.course,
      level: values?.level,
      referralCode: values?.referralCode,
      referralBy: values?.referralBy,
      bankAccountDetails: values.bankAccountDetails.map(
        (accountDetails): any => ({
          accountHolderName: accountDetails.accountHolderName,
          bankAccountNumber: accountDetails.bankAccountNumber,
          ifscCode: accountDetails.ifscCode,
          bankName: accountDetails.bankName,
          branchName: accountDetails.branchName,
        })
      ),
      address: values.address.map((address): any => ({
        country: address.country,
        state: address.state,
        city: address.city,
        pincode: address.pincode,
        addressLine: address.addressLine,
        landmark: address.landmark,
        addressType: address.addressType,
      })),
    };
    addUser(payload).then((res: any) => {
      if (res?.error) {
        showToast("error", res?.error?.data?.message);
      } else {
        if (res?.data?.status) {
          showToast("success", res?.data?.message);
          resetForm();
          onClose();
        } else {
          showToast("error", res?.data?.message);
        }
      }
      setSubmitting(false);
    });
  };

  return (
    <Dialog open maxWidth="md" fullWidth>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {(formikProps) => (
          <Form>
            <UserForm
              formikProps={formikProps}
              onClose={onClose}
              formType="ADD"
            />
          </Form>
        )}
      </Formik>
    </Dialog>
  );
};

export default AddUserFormWrapper;
